import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-database-02',
  standalone: true,
  templateUrl: './rt-icon-database-02.component.html',
  styleUrls: ['./rt-icon-database-02.component.scss']
})
export class RtIconDatabase02Component {
  @Input() width: number | string = 15;
  @Input() height: number | string = 17;
}
